import "../../assets/ParticipantInfo.css";
import { jsxs as l, jsx as i } from "react/jsx-runtime";
import { c as s } from "../../index-0371017d.js";
import { Badge as z } from "../Badge/Badge.js";
const h = "_participantInfo_12ep5_26", u = "_title_12ep5_31", x = "_horizontal_12ep5_35", T = "_vertical_12ep5_45", f = "_subTitle_12ep5_50", I = "_avatar_12ep5_55", C = "_size36_12ep5_71", F = "_size48_12ep5_76", b = "_size100_12ep5_81", S = "_initials_12ep5_86", $ = "_text_12ep5_90", y = "_horizontalText_12ep5_96", O = "_verticalText_12ep5_101", j = "_medium_12ep5_106", A = "_large_12ep5_110", N = "_selected_12ep5_118", U = "_avatarBg5_12ep5_129", k = "_avatarBg6_12ep5_132", E = "_avatarBg7_12ep5_135", G = "_avatarBg8_12ep5_138", L = "_avatarBg9_12ep5_141", P = "_avatarBg10_12ep5_144", R = "_avatarBg11_12ep5_147", Z = "_avatarBg12_12ep5_150", q = "_avatarBg13_12ep5_153", w = "_avatarBg14_12ep5_156", D = "_avatarBg15_12ep5_159", H = "_avatarBg16_12ep5_162", a = {
  participantInfo: h,
  title: u,
  horizontal: x,
  vertical: T,
  subTitle: f,
  avatar: I,
  size36: C,
  size48: F,
  size100: b,
  initials: S,
  text: $,
  horizontalText: y,
  verticalText: O,
  medium: j,
  large: A,
  selected: N,
  avatarBg5: U,
  avatarBg6: k,
  avatarBg7: E,
  avatarBg8: G,
  avatarBg9: L,
  avatarBg10: P,
  avatarBg11: R,
  avatarBg12: Z,
  avatarBg13: q,
  avatarBg14: w,
  avatarBg15: D,
  avatarBg16: H
}, J = {
  small: {
    avatar: a.size36,
    titleFont: a.medium
  },
  medium: {
    avatar: a.size48,
    titleFont: a.medium
  },
  large: {
    avatar: a.size100,
    titleFont: a.large
  }
}, g = [
  a.avatarBg5,
  a.avatarBg6,
  a.avatarBg7,
  a.avatarBg8,
  a.avatarBg9,
  a.avatarBg10,
  a.avatarBg11,
  a.avatarBg12,
  a.avatarBg13,
  a.avatarBg14,
  a.avatarBg15,
  a.avatarBg16
], K = (e) => {
  const r = e.split("").map((t) => t.charCodeAt(0)).reduce((t, _) => t + _, 0) % g.length;
  return g[r];
}, M = (e, r) => {
  let t = e ? e[0].toUpperCase() : "";
  return t += r ? r[0].toUpperCase() : "", t;
}, Q = (e) => e === "horizontal" ? a.horizontal : a.vertical, aa = ({
  uuid: e,
  firstName: r,
  lastName: t,
  subtitle: _,
  image: o,
  format: c = "horizontal",
  size: p = "medium",
  selected: B,
  count: n,
  lastNameFirst: d = !1
}) => {
  const v = J[p], m = d ? `${t}, ${r}` : `${r} ${t}`;
  return /* @__PURE__ */ l(
    "div",
    {
      className: s(Q(c), a.participantInfo, {
        [a.selected]: B
      }),
      children: [
        /* @__PURE__ */ i(
          "div",
          {
            className: s(
              a.avatar,
              v.avatar,
              K(e)
            ),
            children: o ? /* @__PURE__ */ i("img", { src: o, alt: "profile image" }) : /* @__PURE__ */ i("p", { className: a.initials, children: M(r, t) })
          }
        ),
        /* @__PURE__ */ l(
          "div",
          {
            className: s(
              c === "horizontal" ? a.horizontalText : a.verticalText,
              a.text
            ),
            children: [
              /* @__PURE__ */ i("div", { className: s(v.titleFont, a.title), children: m }),
              /* @__PURE__ */ i("div", { className: a.subTitle, children: _ })
            ]
          }
        ),
        typeof n < "u" && n > 0 && /* @__PURE__ */ i(z, { count: n })
      ]
    }
  );
};
export {
  aa as ParticipantInfo
};
